module.exports = __webpack_public_path__ + "static/media/logo.2f16a74a.png";